// Local DEV Setup
export const LOCAL_URL = 'http://localhost:8080';
// Common
export const URL = process.env.NODE_ENV !== 'development' ? window.location.origin : LOCAL_URL;

export const API = '/api';
export const VERSION = '/v1';
export const SEARCH = '/search';
export const DROPDOWN = '/dropdown';
export const REF_DATA = '/referencedata';
export const REF_DATA_NETWORK = `${REF_DATA}/networks`;
export const REF_DATA_BRANCH = `${REF_DATA}/branch`;

// Base URL
export const BASE_URL = `${URL}${API}${VERSION}`;
export const URI = window.location.origin;
